import {
  DashboardOutlined,
  SettingOutlined,
  CalculatorOutlined,
  HistoryOutlined,
  PartitionOutlined,
  FileTextOutlined,
  UsergroupAddOutlined,
  CrownOutlined,
  BarChartOutlined,
  CustomerServiceOutlined,
  WalletOutlined,
  FileOutlined,
} from "@ant-design/icons-vue";

interface MenuItem {
  key: string;
  label: string;
  path: string;
  icon: () => VNode;
}

export const customMenus = [
  // { key: "dashboard", label: "", path: "/dashboard", icon: () => h(DashboardOutlined) },
  // { key: "usage", label: "", path: "/usage", icon: () => h(BarChartOutlined) },
  // { key: "calculate", label: "", path: "/calculate", icon: () => h(CalculatorOutlined) },
  // { key: "calculations", label: "", path: "/calculations", icon: () => h(HistoryOutlined) },
  // { key: "templates", label: "", path: "/templates", icon: () => h(FileOutlined) },
  // { key: "factors", label: "", path: "/factors", icon: () => h(PartitionOutlined) },
  { key: "reports", label: "", path: "/reports", icon: () => h(FileTextOutlined) },
  // { key: "invite", label: "", path: "/invite", icon: () => h(UsergroupAddOutlined) },
  // { key: "upgrade", label: "", path: "/upgrade", icon: () => h(CrownOutlined) },
  { key: "billing", label: "", path: "/billing", icon: () => h(WalletOutlined) },
  { key: "tickets", label: "", path: "/tickets", icon: () => h(CustomerServiceOutlined) },
  // { key: "settings", label: "", path: "/settings", icon: () => h(SettingOutlined) },
];

const showInLoginedPaths = [
  "notifications",
  "billing",
  "tickets",
  "calculations",
  "reports",
  "pay-per-use",
  "news",
];

/**
 * useMenu is a custom hook that provides menus and the current selected key.
 * @returns
 */
export const useMenus = () => {
  const menus = ref<MenuItem[]>([]);
  const currentKey = ref<string>("dashboard");
  const { t, locale } = useI18n();
  const router = useRouter();
  function getMenuItems() {
    menus.value = customMenus.map(item => {
      item.label = t(`layout.menu.${item.key}`);
      return item;
    });
  }
  watchEffect(() => {
    getMenuItems();
    const path = router.currentRoute.value.path;
    if (showInLoginedPaths.some(item => path.includes(item))) {
      currentKey.value = "showInLogined";
      return;
    }
    const matchedItem = menus.value.find(item => item.path === path);
    currentKey.value = matchedItem?.key || "";
  });
  watch(() => locale.value, getMenuItems, { immediate: true });
  const showLoginedMenu = computed(() => !!currentKey.value);
  return { menus, currentKey, showLoginedMenu };
};
